<h2>Buttons</h2>
<div class="flex flex-wrap space-x-4">
  <button class="btn">Default</button>
  <button class="btn-dark">Dark</button>
  <button class="btn-dark bg-cyan-900">Blue</button>
  <button class="bg-red-900 btn-dark">Button</button>
  <button class="btn-dark bg-violet-900"> Button</button>
  <button class="btn-dark bg-emerald-900">Button</button>
  <button disabled class="btn">Disabled</button>
</div>
